import React, { useState, useEffect } from 'react';
import Link from 'next/link';

import { ajaxor2, ajaxor0, apiHome } from '../common/basic';
import getNLS from '../common/_NLS';

const awsURL = "https://s3.ap-northeast-2.amazonaws.com/camscon.seoul";

export default props=>{
  if(!process.browser) return <></>;

  const [vWeeklyBest, setWeeklyBest] = useState([]);

  useEffect(() => {
    ajaxor2({
      url: "/magazineR4",
      callback: setWeeklyBest,
    });

    return () => { };
  }, []);

  return (<div className="pan5">
    <style jsx>{`

.display-inline{
  display: inline;
  margin: 0 2.5%;
  vertical-align: middle;
  
}

.MOST-POPULAR {
  font-size: 18px;
font-weight: bold;
  color: #343a40;
  padding: 4px 0 24px 0;
}

.fourinone{
  width:1290px;
}

.fourinone td{
  width: 300px;
  min-width: 29px;
  padding: 0;
}

.item {
  width: 300px;
  height: 200px;
  padding: 0;
  margin: 0;
  border: 0;

  position: relative;
}

img {
  width: 100%;
  height: auto;
}

.frame{
  width: 100%;
  overflow-y: hidden;
}

.frame::-webkit-scrollbar { 
    display: none; 
}



.item .best4{
  position: absolute;
  /* left: 15px; */
  /* bottom: 31px; */
  /* bottom: 13px; */
  left:10px;
  right:10px;
  bottom:10px;

  font-size: 13px;
  font-weight: 500;
  line-height: 1.38;
  letter-spacing: -0.25px;
  color: #ffd43b;
}


.item .Inspired-by-Camscon{
  position: absolute;
  left: 15px;
  bottom: 13px;

  font-size: 13px;
  line-height: 1.38;
  letter-spacing: -0.25px;
  color: #ffffff;

}


.item .Inspired-by-Camscon2{
  /* position: absolute;
  left: 15px;
  bottom: 13px; */

  font-size: 13px;
  line-height: 1.38;
  letter-spacing: -0.25px;
  color: #ffffff;

}


@media all and (max-width:606px) {
  .sss{display: none;}
  .MOST-POPULAR {
    padding: 4px 0 8px 0;
  }
}


`}</style>
    <div className="MOST-POPULAR">{getNLS("인기 기사")}</div>

    <div className="frame" >
      <table className="fourinone"><tbody>
        <tr className="aline">

          {vWeeklyBest && vWeeklyBest.map((v,i)=>(<>
            <td key={'aa'+i} className="">
              <Link href={"/magazine/" + (v && v.id)}><a>
                <div className="item base leftside">
                  <img className="" src={
                    ((JSON.parse(v.caption)).thumbnail
                      ? apiHome.split('/v1').join('') + (JSON.parse(v.caption)).thumbnail.targetFullPath
                      : "/assets/images/crop/wb3.png")
                  } />
                  <div className="best4">BEST {i+1}
                    {/* <div className="Inspired-by-Camscon">{v.username}</div> */}
                    <div className="Inspired-by-Camscon2">{v.title}</div>
                  </div>
                </div>
              </a></Link>
            </td>
            <td key={'bb' + i}></td>

          </>))}

        </tr>
      </tbody></table>

    </div>
  </div>);
};

